import { ContractStageType } from "../../../../models/Entities/Contracts/ContractStageType";
import { ErrorType } from "../../../../models/HttpError";

// store 
import * as ContractStageTypeStore from "../../../../redux/middleware/ContractStageType.Middleware";
import { AppState } from "../../../../redux/reducers";

interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
}
  
interface ConnectedProps {
    isLoading: boolean;
    isLoadingSuccessfully: boolean;
    failOnLoading: boolean;
    error: ErrorType | undefined;
    ContractStageTypes: ContractStageType[];
}


interface DispatchProps {
    GetAllContractsStageTypes: typeof ContractStageTypeStore.actionCreators.GetAllContractsStageTypes;
    DeleteContractStageType: typeof ContractStageTypeStore.actionCreators.DeleteContractStageType;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoading: state.ContractStageType?.isLoadingAll,
    isLoadingSuccessfully: state.ContractStageType?.successLoadingAll,
    failOnLoading: state.ContractStageType?.failOnLoadingAll,
    error: state.ContractStageType?.error,
    ContractStageTypes: (state.ContractStageType?.list || [])
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name)),
    isAddingNewOne: state.ContractStageType?.isAddingNewOne || false,
    isUpdatingOne: state.ContractStageType?.isUpdatingOne || false,
    isDeletingOne: state.ContractStageType?.isDeletingOne || false,
});

export const mapDispatchToProps = ({
...ContractStageTypeStore.actionCreators
});